import { isMobile } from '@/utils'

const sendLog = (object = '', option = {}, type = 'click') => {
  try {
    const { $h } = window
    if ($h && typeof $h.a2s !== 'undefined') {
      if (type === 'click') {
        $h.a2s.sendClickLog(object, JSON.stringify(option))
      } else if (type === 'contents') {
        $h.a2s.sendContentsLog(object, JSON.stringify(option))
      }
    }
  } catch (e) {
    console.log(e)
  }
}
// (function(w, d, s, l) {
//   function createScriptTag(src, onload) {
//     var tag = d.createElement(s)
//     tag.async = true
//     tag.src = src
//     if (typeof onload === 'function') {
//       tag.onload = onload
//     }
//     return tag
//   }
//
//   w[l] = w[l] || []
//
//   /* GA 코드 */
//   var h = d.getElementsByTagName('head')[0] ,
//     gaId = 'UA-116900215-1',
//     g = createScriptTag(`https://www.googletagmanager.com/gtag/js?id=${gaId}`)
//   w.gtag = function() {
//     w[l].push(arguments)
//   }
//   gtag('js', new Date())
//   gtag('config', gaId)
//   h.appendChild(g)
//   /* GA 코드 끝 */
//
//   /* GTM 코드 */
//   w[l].push({
//     'gtm.start': new Date().getTime(),
//     event: 'gtm.js'
//   })
//   var gtmId = 'GTM-K8LP3ZB',
//     dl = l != 'dataLayer' ? '&l=' + l : '',
//     j = createScriptTag(
//       `https://www.googletagmanager.com/gtm.js?id=${gtmId}${dl}`
//     )
//   h.appendChild(j)
//   /* GTM 코드 끝 */
//
//   /* A2S 코드 */
//   /*
//     PC Web: http://js.nx.com/s1/da/playlog.min.js (https://ssl.nx.com/s1/da/playlog.min.js)
//     Mobile Web: http://js.nx.com/s1/da/playlog.mobile.min.js (https://ssl.nx.com/s1/da/playlog.mobile.min.js)
//   */
//   var a = createScriptTag(isMobile ? `https://ssl.nx.com/s1/da/playlog.mobile.min.js` : `https://ssl.nx.com/s1/da/playlog.min.js` )
//   h.appendChild(a)
//   /* A2S 코드 끝*/
// })(window, document, 'script', 'dataLayer')

export default sendLog
